import { gql, TypedDocumentNode } from "@apollo/client";

import { IntentProject, QueryIntentProjectArgs } from "types/generated";

export const GET_INTENT_PROJECT_INTEGRATION: TypedDocumentNode<
  { intentProject: Pick<IntentProject, "id" | "awsIntegrationIntentProjectAttachment"> },
  QueryIntentProjectArgs
> = gql`
  query GetIntentProjectIntegration($id: ID!) {
    intentProject(id: $id) {
      id
      awsIntegrationIntentProjectAttachment {
        id
        read
        write
        awsRegion
        awsIntegration {
          id
          name
          labels
          roleArn
          durationSeconds
          externalId
          spaceDetails {
            id
            name
          }
        }
      }
    }
  }
`;
